import { createContext } from 'react';
import { BakeasyLoaderProp } from '../components/loaders/BakeasyLoader';
import { BakeasySnackbarProp } from '../components/snackbars/BakeasySnackBar';
import { BakeasyConfirmDialogProp } from '../components/dialogs/BakeasyConfirmDialog';
import { BakeasyDialogProp } from '../components/dialogs/BakeasyDialog';

export interface AppContextPropTypes {
  loader: BakeasyLoaderProp;
  setLoader: React.Dispatch<React.SetStateAction<BakeasyLoaderProp>>;
  dialog: BakeasyDialogProp;
  setDialog: React.Dispatch<React.SetStateAction<BakeasyDialogProp>>;
  snackbar: BakeasySnackbarProp;
  setSnackbar: React.Dispatch<React.SetStateAction<BakeasySnackbarProp>>;
  confirmDialog: BakeasyConfirmDialogProp;
  setConfirmDialog: React.Dispatch<React.SetStateAction<BakeasyConfirmDialogProp>>;
  isMobileView: boolean;
  setIsMobileView: React.Dispatch<React.SetStateAction<boolean>>;
}
export const AppContext = createContext<AppContextPropTypes>({
  loader: {},
  setLoader: () => {},
  dialog: {},
  setDialog: () => {},
  snackbar: {},
  setSnackbar: () => {},
  confirmDialog: {},
  setConfirmDialog: () => {},
  isMobileView: true,
  setIsMobileView: () => {}
});
